<template>
    <div class="container-fluid" id="nav-div">

        <nav class="navbar navbar-expand-md bg-light navbar-light">
            <img :src="'/assets/images/logo.png'" style="width: 10%;" alt="FinditSmart">

            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="collapsibleNavbar">
                <ul class="navbar-nav w-100 ">
                    <li class="nav-item home">
                        <router-link class="nav-link" active-class="active" exact-active-class="active" to="/home">HOME</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" active-class="active" to="/blog">BLOG POSTS</router-link>
                    </li>
                    <li class="nav-item" style="display: flex;" id="dropdown-menu">
                        <span class="nav-link" :class="{ 'active': isPackagesActive }" style="cursor: default;">PACKAGES</span>
                        <button id="dropbtn-menu"><i class="fa fa-caret-down"></i>
                        </button>
                        <div class="dropdown-menu-content">
                           <ul><li id="dropdown-menu-1">
                               <router-link to="/packages/link1" active-class="active-submenu" class="dropdown-link">Link 1</router-link>
                                   <ul class="dropdown-submenu-content">
                                       <li><router-link to="/packages/link1/sublink1" active-class="active-submenu" class="dropdown-link">Sub Link 1</router-link> </li>
                                       <li><router-link to="/packages/link1/sublink2" active-class="active-submenu" class="dropdown-link">Sub Link 2</router-link> </li>
                                       <li><router-link to="/packages/link1/sublink3" active-class="active-submenu" class="dropdown-link">Sub Link 3</router-link> </li>
                                       <li><router-link to="/packages/link1/sublink4" active-class="active-submenu" class="dropdown-link">Sub Link 4</router-link> </li>

                                   </ul>
                           </li>
                               <li>
                               <router-link to="/packages/link2" active-class="active-submenu" class="dropdown-link">Link 2</router-link>
                               </li>
                               <li>
                               <router-link to="/packages/link3" active-class="active-submenu" class="dropdown-link">Link 3</router-link>
                               </li>
                           </ul>
                        </div>
                    </li>
                    <li class="nav-item" style="display: flex;" id="dropdown-menu-about">
                        <span class="nav-link" :class="{ 'active': isAboutActive }" style="cursor: default;">ABOUT US</span>
                        <button id="dropbtn-menu-about"><i class="fa fa-caret-down"></i>
                        </button>
                        <div class="dropdown-menu-content">
                           <ul>
                               <li>
                               <router-link to="/page/who-we-are" class="dropdown-link" :class="{ 'active-submenu': isWhoWeAreActive }">Who We Are</router-link>
                               </li>
                               <li>
                               <router-link to="/page/what-we-do" class="dropdown-link" :class="{ 'active-submenu': isWhatWeDoActive }">What We Do</router-link>
                               </li>
                           </ul>
                        </div>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" active-class="active" to="/itenary">CONTACT US</router-link>
                    </li>
                    <li class="nav-item" style="display: none;">
                        <a class="nav-link" href="#" id="signup">SIGN UP</a>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</template>



<script lang="ts">
import { defineComponent } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default defineComponent({
  name: 'fis-header',
  props: {
    name: String
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    
    return {
      route,
      router
    };
  },
  computed: {
    isPackagesActive(): boolean {
      const packagesRoutes = [
        '/packages/link1',
        '/packages/link1/sublink1',
        '/packages/link1/sublink2',
        '/packages/link1/sublink3',
        '/packages/link1/sublink4',
        '/packages/link2',
        '/packages/link3'
      ];
      return packagesRoutes.some(routePath => this.route.path.startsWith(routePath));
    },
    isAboutActive(): boolean {
      return this.isWhoWeAreActive || this.isWhatWeDoActive;
    },
    isWhoWeAreActive(): boolean {
      return this.route.path === '/page/who-we-are';
    },
    isWhatWeDoActive(): boolean {
      return this.route.path === '/page/what-we-do';
    }
  }
});

</script>


<style scoped>
.navbar-nav .nav-link {
  font-weight: 700 !important;
}
</style>
